import { connect } from 'react-redux';
import { IndexComponent } from './../../components/Calculators/IndexComponent';

const mapStateToProps = state => (state);
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(IndexComponent);


// WEBPACK FOOTER //
// ./src/containers/Calculators/Calculators.js